import { gql } from "@apollo/client";

export const UPDATE_PAYMENT_GUIDELINE = gql`
  mutation updateShownDeeplePayGuidelinePopup($projectId: ID!) {
    updateShownDeeplePayGuidelinePopup(projectId: $projectId) {
      isShownDeeplePayGuidelinePopup
    }
  }
`;
